// Stany gry. Etap A nie ma jeszcze edytora, ale maszyna stanow jest juz docelowa.

export type GameState = 'editing' | 'running' | 'paused' | 'won' | 'failed';

export type TrialOutcomeName = 'won' | 'timeout' | 'out_of_bounds' | 'flipped' | 'stuck';

export function isTrialOver(state: GameState): boolean {
  return state === 'won' || state === 'failed';
}

/** Zamienia wynik proby na stan gry. Kazde zakonczenie inne niz sukces to 'failed'. */
export function outcomeToState(outcome: TrialOutcomeName): GameState {
  return outcome === 'won' ? 'won' : 'failed';
}
